export const ABLVerificationStatus = {
  Failed: 1,
  OverrideFailed: 2,
  ActionRequired: 3,
  NotVerified: 4,
  InPending: 5,
  Verified: 6,
  OverrideVerified: 7,
  VerifiedLimited: 9,
};

export const ABLVerificationFailedStatusList = [ABLVerificationStatus.Failed, ABLVerificationStatus.OverrideFailed];

export const ABLVerificationVerifiedStatusList = [ABLVerificationStatus.Verified, ABLVerificationStatus.OverrideVerified, ABLVerificationStatus.VerifiedLimited];

export const AccountVerificationStatus = {
  Failed: 1,
  OverrideFailed: 2,
  ActionRequired: 3,
  NeedVerified: 4,
  InPending: 5,
  Verified: 6,
  OverrideVerified: 7,
  NoNeedVerified: 8,
  VerifiedLimited: 9,
};

export const AccountVerificationFailedStatusList = [AccountVerificationStatus.Failed, AccountVerificationStatus.OverrideFailed];

export const AccountVerificationVerifiedStatusList = [AccountVerificationStatus.Verified, AccountVerificationStatus.OverrideVerified, AccountVerificationStatus.VerifiedLimited];

export const AccountToAblVerificationStatusRelation = {
  [AccountVerificationStatus.Failed]: ABLVerificationFailedStatusList,
  [AccountVerificationStatus.OverrideFailed]: ABLVerificationFailedStatusList,
  [AccountVerificationStatus.ActionRequired]: [ABLVerificationStatus.ActionRequired],
  [AccountVerificationStatus.NeedVerified]: [ABLVerificationStatus.NotVerified],
  [AccountVerificationStatus.InPending]: [ABLVerificationStatus.InPending],
  [AccountVerificationStatus.Verified]: ABLVerificationVerifiedStatusList,
  [AccountVerificationStatus.OverrideVerified]: ABLVerificationVerifiedStatusList,
  [AccountVerificationStatus.NoNeedVerified]: null, // This value indicates that any ABLVerificationStatus is OK. Choosing nul arbitrary, can be changed later per need.
  [AccountVerificationStatus.VerifiedLimited]: ABLVerificationVerifiedStatusList,
};

export const AccountVerificationStatusIconMapping = {
  Failed: {
    glyph: 'ba-Error',
    iconStyle: 'error',
    textStyle: 'error',
  },
  OverrideFailed: {
    glyph: 'ba-Error',
    iconStyle: 'error',
    textStyle: 'error',
  },
  ActionRequired: {
    glyph: 'ba-Warning',
    iconStyle: 'error',
    textStyle: 'error',
  },
  NeedVerified: {
    glyph: 'ba-Warning',
    iconStyle: 'warning',
    textStyle: 'warning',
  },
  InPending: {
    glyph: 'ba-HourGlass',
    iconStyle: 'default',
    textStyle: 'default',
  },
  Verified: {
    glyph: 'ba-VerifiedBrandSolid',
    iconStyle: 'primary',
  },
  OverrideVerified: {
    glyph: 'ba-VerifiedBrandSolid',
    iconStyle: 'primary',
  },
  NoNeedVerified: {
    glyph: 'ba-Info',
    iconStyle: 'default',
    textStyle: 'default',
  },
  VerifiedLimited: {
    glyph: 'ba-VerifiedBrandSolid',
    iconStyle: 'primary',
  },
};

export const VerificationType = {
  Individual: '1',
  Business: '2',
};

export const DocumentVerifiedStatus =
{
  NotVerified: 1,
  Verified: 2,
  Failed: 3,
};

export const UnableTriggerAivReason =
{
  InternalUser: 1,
  NoRemainingRetryCount: 2,
  UserRoleMismatch: 3,
  NotAccountOwner: 4,
  InitializeInProgress: 5,
  OverrideFailed: 6,
};


export const OrderedUnableTriggerAivReasons =
  [
    UnableTriggerAivReason.InternalUser,
    UnableTriggerAivReason.NotAccountOwner,
    UnableTriggerAivReason.UserRoleMismatch,
    UnableTriggerAivReason.OverrideFailed,
    UnableTriggerAivReason.NoRemainingRetryCount,
    UnableTriggerAivReason.InitializeInProgress,
  ];

export const AivFailureReasons = {
  Onfido_Rejected_ImageIntegrity_ImageQuality: 101,
  Onfido_Rejected_ImageIntegrity_SupportedDocument: 102,
  Onfido_Rejected_ImageIntegrity_ColourPicture: 103,
  Onfido_Caution_DataConsistency_MultipleDataSourcesPresent: 104,
  Onfido_Caution_VisualAuthenticity_OriginalDocumentPresent: 105,
  Onfido_Caution_FaceComparison_FaceMatch: 106,
  Onfido_Caution_DataValidation_DocumentExpiration: 107,
  Onfido_Caution_DataComparison_FirstName: 108,
  Onfido_Caution_DataComparison_LastName: 109,
  Onfido_Caution_ImageIntegrity_ConclusiveDocumentQuality: 110,
  Onfido_Caution_ImageIntegrity_ColorPicture: 111,
  Onfido_Caution_ImageIntegrity_PictureUnavailableInDocument: 112,
  OneVet_Email_Verification_Failure: 201,
  OneVet_Business_Verification_Failure: 202,
  OneVet_Domain_Verification_Failure: 203,
};
